/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from 'react';
import './index.scss';

import Assistapply from './Assistapply';

import Page from './../../components/page/page2';

import { BaseFetch } from './../../context';

const Mainapply = props => {

  const { tafFetch, tafJce, lActId_, lPid_ } = useContext(BaseFetch);

  const [inviteList, changeInviteWhole] = useState([]); // 邀请总榜单
  const [showInviteList, changeInviteShow] = useState([]); // 邀请展示榜单

  const [recordList, changeRecordWhole] = useState([]); // 记录总榜单
  const [showRecordList, changeRecordShow] = useState([]); // 记录展示榜单

  // 选择展示的tab
  const [tabSelect, changeTab] = useState(0);

  // 主播四种类型：1.已报名未邀请嘉宾，2.已报名未邀请嘉宾，3.未报名成为嘉宾，4.未报名未成为嘉宾
  const [userType, changeUserType] = useState(-1);

  // 分区列表(iStatus:1、不可选，2、已选，0、可选)
  const [areaList, changeList] = useState([]);

  // 助阵嘉宾
  const [helpMsg, changeHelper] = useState(null);

  // 主播是否已报名(通过是否为空判断)
  const [userApplyArea, changeArea] = useState(null);

  // 主播能否报名
  const [canApply, changeCanA] = useState(0);
  useEffect(() => {
    if (tafFetch === null || tafJce === null) return;

    initData();

  }, [tafFetch, tafJce]);

  // 初始化数据
  const initData = () => {
    changeCanA(0);changeArea(null);changeInviteShow([]);changeRecordWhole([]);changeRecordShow([]);changeTab(0);changeInviteWhole([]);changeHelper(null);changeSelect(null);

    tafFetch('queryApplyConfig', {lPid: lPid_, lActId: lActId_}, tafJce.ApplyConfigReq, tafJce.ApplyConfigRsp).then(val => {
      console.log('分区请求参数', {lPid: lPid_, lActId: lActId_}, val);
      if (val.iResult !== 0) return;

      let list = val.vAreaList.value.length > 3 ? val.vAreaList.value.slice(0, 3) : val.vAreaList.value;

      // 判断是否已报名, true 已报名, false 未报名
      const hasApply = val.iApplyAreaId !== 0;
      if (val.iAllowApply === 1) {
        changeCanA(1);
        if (hasApply) {
          if (val.iRoleType === 0) {
            changeUserType(1);
            getList(1);
          }
          if (val.iRoleType === 1) {
            changeUserType(2);
            getList(2);
          }

          for (let i = 0; i < list.length;) {
            // 主播已报名
            if (list[i].iAreaId === val.iApplyAreaId) {
              changeArea(list[i]);
              list = list.map(item => {
                if (item.iStatus !== 2) {
                  return { ...item, iStatus: 1 }
                }
                return { ...item }
              })
              break;
            }
            i += 1;
          }

        } else {
          if (val.iRoleType === 0) {
            changeUserType(4);
            getList(4);
          }
          if (val.iRoleType === 2) {
            list = list.map(item => ({ ...item, iStatus: 1 }))
            changeUserType(3);
            getList(3);
          }
        }
      } else {
        changeCanA(0);
        list = list.map(item => ({ ...item, iStatus: 1 }))
        if (val.iRoleType === 0) {
          changeUserType(4);
          getList(4);
        }
        if (val.iRoleType === 2) {
          changeUserType(3);
          getList(3);
        }
      }
      changeList(list);

    })
  }

  // 根据用户不同状态获取列表
  const getList = type => {
    if (type === 1) {
      tafFetch('queryAssistUser', {lUid: lPid_, sNickName: '', iTimes: 0, lActId: lActId_}, tafJce.ActSearchUserReq, tafJce.ActSearchUserRsp).then(val => {
        console.log('邀请助阵嘉宾列表', {lUid: lPid_, sNickName: '', iTimes: 0, lActId: lActId_}, val.vItems.value);
        let list = val.vItems.value.length > 15 ? val.vItems.value.slice(0, 15) : val.vItems.value;
        list = list.map((item, index) => ({...item, index: index + 1}))
        changeInviteWhole(list);
        changeInviteShow(list.slice(0, 3 >= list.length ? list.length : 3));
      })
      return;
    }
    if (type === 2 || type === 3) {
      tafFetch('queryAssistInfo', {lUid: lPid_, iRoleType: type - 1, lActId: lActId_}, tafJce.AssistInfoReq, tafJce.AssistInfoRsp).then(val => {
        console.log('助阵嘉宾', {lUid: lPid_, iRoleType: type - 1, lActId: lActId_}, val.vAssistInfo);
        changeHelper(val.vAssistInfo);
      })
      return;
    }
    if (type === 4) {
      tafFetch('queryAssistList', {lUid: lPid_, lActId: lActId_}, tafJce.InviteListReq, tafJce.InviteListRsp).then(val => {
        console.log('他人邀请记录', {lUid: lPid_, lActId: lActId_}, val)
        let list = val.vInviteeList.value.length > 20 ? val.vInviteeList.value.slice(0, 20) : val.vInviteeList.value;
        list = list.map((item, index) => ({...item, index: index + 1}))
        changeRecordWhole(list);
        changeRecordShow(list.slice(0, 4 >= list.length ? list.length : 4));
      })
      return;
    }
  }

  // eslint-disable-next-line no-underscore-dangle
  const pageChange = index => {
    changeInviteShow(inviteList.slice((index) * 3, (index + 1) * 3 > inviteList.length ? inviteList.length : (index + 1) * 3));
  }
  // eslint-disable-next-line no-underscore-dangle
  const pageChange_ = index => {
    changeRecordShow(recordList.slice((index) * 4, (index + 1) * 4 > recordList.length ? recordList.length : (index + 1) * 4));
  }

  // 未报名时选中的分区
  const [selectArea, changeSelect] = useState(null);

  // 赛区选择
  const choose = params => {
    const { iAreaId, iStatus } = { ...params };

    // 赛区不可选或已报名
    if (iStatus === 1 || userApplyArea !== null) return;

    // 取消已选状态
    if (iStatus === 2) {
      let list  = areaList;
      list  = list.map(item => ({...item, iStatus: item.iStatus === 1 ? 1 : 0}));
      changeList(list);
      changeSelect(null);
    }

    // 选中某个赛区
    if (iStatus === 0) {
      let list  = areaList;
      list  = list.map(item => {
        if (item.iAreaId === iAreaId) {
          changeSelect(item)
          return {...item, iStatus: 2};
        }
        return {...item, iStatus: item.iStatus === 1 ? 1 : 0};
      })
      changeList(list)
    }
  }

  // 报名/重新报名按钮
  const comfirm = () => {
    // 立即报名
    if (userApplyArea === null) {
      console.log(selectArea);
      if (selectArea === null) {
        fetchData({});
        openCloseT(-1);
        return;
      };
      fetchData(selectArea);
      openCloseT(1);
    // 重新报名
    } else {
      fetchData(userApplyArea);
      if (userType === 2) {
        openCloseT(3);
        return;
      }
      openCloseT(2);
    }
  }

  // 切换tab
  const changeTabcall = index => {
    if (index === tabSelect) return;
    changeTab(index);
    if (index === 0) {
      tafFetch('queryAssistUser', {lUid: lPid_, sNickName: '', iTimes: 0, lActId: lActId_}, tafJce.ActSearchUserReq, tafJce.ActSearchUserRsp).then(val => {
        console.log('邀请助阵嘉宾列表',  {lUid: lPid_, sNickName: '', iTimes: 0, lActId: lActId_}, val.vItems.value);
        let list = val.vItems.value.length > 15 ? val.vItems.value.slice(0, 15) : val.vItems.value;
        list = list.map((item, index) => ({...item, index: index + 1}))
        changeInviteWhole(list);
        changeInviteShow(list.slice(0, 3 >= list.length ? list.length : 3));
      })
    } else {
      tafFetch('queryAssistList', {lUid: lPid_, lActId: lActId_}, tafJce.InviteListReq, tafJce.InviteListRsp).then(val => {
        console.log('邀请我的列表', {lUid: lPid_, lActId: lActId_}, val)
        let list = val.vInviteeList.value.length > 20 ? val.vInviteeList.value.slice(0, 20) : val.vInviteeList.value;
        list = list.map((item, index) => ({...item, index: index + 1}))
        changeRecordWhole(list);
        changeRecordShow(list.slice(0, 4 >= list.length ? list.length : 4));
      })
    }
  }

  // 二次弹窗开关
  const [twiceToast, openCloseT] = useState(-2);
  const [toastData, fetchData] = useState(null);
  // 二次弹窗关闭
  const closeAssist = type => {

    if (type) {
      // 重新拉一遍数据
      initData();
    }

    fetchData(null);
    openCloseT(-2);
  }

  //  监听邀请搜索框
  const [inputValue, inputChange_] = useState('');
  const inputChange = event => {
    inputChange_(event.target.value);
  }
  // 发起邀请搜索
  const search = () => {
    changeInviteWhole([]);changeInviteShow([]);
    tafFetch('queryAssistUser', {lUid: lPid_, sNickName: inputValue, iTimes: inputValue === '' ? 1 : 0, lActId: lActId_}, tafJce.ActSearchUserReq, tafJce.ActSearchUserRsp).then(val => {
      console.log('邀请助阵嘉宾列表参数', {lUid: lPid_, sNickName: inputValue, iTimes: inputValue === '' ? 1 : 0, lActId: lActId_}, val.vItems.value)
      let list = val.vItems.value.length > 15 ? val.vItems.value.slice(0, 15) : val.vItems.value;
      list = list.map((item, index) => ({...item, index: index + 1}))
      changeInviteWhole(list);
      changeInviteShow(list.slice(0, 3 >= list.length ? list.length : 3));
    })
  }

  // 发起邀请
  const invite = id => {
    fetchData({lInviteeUid: id});
    openCloseT(8);
  }

  // 接受或者拒绝助阵
  const acceptRefuse = (type, id) => {
    if (type === 1) {
      openCloseT(4);
    } else {
      openCloseT(5);
    }
    fetchData({uid: id})
  }

  // 解除助阵关系
  const lift = (id, type, name) => {
    fetchData({lOperPid: id, sNickName: name});
    openCloseT(type);
  }

  // 数字转万单位
  const figureChange = num => {
    let result = num;

    if (num > 9999) {
      result = (num / 10000).toFixed(2) + 'w';
    }

    return result;
  }

  // 根据主播状态选择展示的tab
  const tabValue = [['邀请助阵嘉宾', '他人邀请记录'], ['助阵嘉宾'], ['助阵对象'], ['他人邀请记录']];

  return (
    <div className='mainapply'>
      <section className='mainapply-title'>
        <p>主播报名</p>
        <i
          onClick = {
            () => {
              props.close()
            }
          }></i>
      </section>
      <section className='mainapply-apply'>
        <div className='mainapply-choose'>
          <div className='mainapply-chooseTitle'>选择赛区:</div>
          <ul>
            {
              areaList.map(item => (
                <li
                  key = {item.iAreaId}
                  className = {
                    (() => {
                      if (item.iStatus === 0) {
                        return 'canselect';
                      }
                      if (item.iStatus === 1) {
                        return 'cantselect';
                      }
                      if (item.iStatus === 2) {
                        return 'hasselect';
                      }
                    })()
                  }
                  onClick = { () => {
                    choose(item)
                  } }
                >{item.sName}新势力</li>
              ))
            }
          </ul>
        </div>
        <div className='mainapply-tips'>
          {
            (() => {
              if (userType === 3 || canApply === 0) {
                return '您不符合报名条件，详情请咨询YY：80313';
              }
              if (userApplyArea === null) {
                return '仅可加入一条赛道比赛，报名截止至12月11号24点';
              } else {
                return (<React.Fragment>您当前已经成功报名 <span>{userApplyArea.sName}新势力</span>，有疑问请咨询YY：80313</React.Fragment>)
              }
            })()
          }
        </div>
        <div className='mainapply-comfirm'
          onClick = { () => {
            comfirm();
          } }
        >
          {
            userApplyArea === null ? '立即报名' : '重新报名'
          }
        </div>
        <ul className='mainapply-tab'>
          {
            userType !== -1 &&
            tabValue[userType - 1].map((item, index) => (
              <li
                key = {index}
                className = {`mainapply-tab-${index === tabSelect ? 'select' : 'noselect'}`}
                onClick = {() => {
                  changeTabcall(index);
                }}
              >{item}</li>
            ))
          }
        </ul>
      </section>
      <section className='mainapply-tabContent'>
        {
          // 他人邀请记录
          ((userType === 1 && tabSelect === 1) || userType === 4) &&
          <div className='mainapply-inviteguest'>
            {
              showRecordList.length === 0 &&
                  <div className='nonedata'>
                    <div></div>
                    <p>当前并无邀请记录</p>
                  </div>
            }
            <div className='mainapply-inviteguest-main'>
              {
                showRecordList.length !== 0 &&
                <div className='main-title'>
                  <p>序号</p><p>主播昵称</p><p>操作</p>
                </div>
              }
              <div className='main-user'>
                {
                  showRecordList.length !== 0 &&
                  showRecordList.map(item => (
                    <div className='main-user-item' key = { JSON.stringify(item) }>
                      <div className='user-item-index'>
                        { item.index }
                      </div>
                      <div className='user-item-msg'>
                        <img
                          className='item-msg-head'
                          src={item.sLogoUrl}
                          // onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                          onError={event => {
                            event.target.onerror = null;
                            event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png'
                          }
                          }
                        />
                        <p className='item-msg-name'>{ item.sNickName }</p>
                        <p className='item-msg-subscribe'>(订阅：<span>{figureChange(item.iSubscription)}</span>)</p>
                      </div>
                      <div className='user-item-control'>
                        {
                          // (item.iOperatorType === 0 || item.iOperatorType === 1) && userType !== 1 &&
                          <React.Fragment>
                            <h4
                              onClick = { () => {
                                acceptRefuse(1, item.lPid);
                              } }
                            >接受</h4>
                            {/* |
                            <h4
                              onClick = { () => {
                                acceptRefuse(2, item.lPid);
                              } }
                            >拒绝</h4> */}
                          </React.Fragment>
                        }
                        {/* {
                          item.iOperatorType === 1 && userType === 1 &&
                          <h5>已邀请</h5>
                        }
                        {
                          item.iOperatorType === 2 &&
                          <h5>已同意</h5>
                        }
                        {
                          item.iOperatorType === 3 &&
                          <h5>已拒绝</h5>
                        }
                        {
                          item.iOperatorType === 4 &&
                          <h5>Ta被人抢走啦</h5>
                        } */}
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
            <div className='mainapply-page'>
              {
                showRecordList.length !== 0 &&
                  <Page
                    pageLen={recordList.length % 4 === 0 ? recordList.length / 4 : Math.floor(recordList.length / 4) + 1}
                    setPageIndex={pageChange_}
                  />
              }
            </div>
          </div>
        }
        {
          // 邀请助阵嘉宾
          userType === 1 && tabSelect === 0 &&
          <div className='mainapply-inviteguest'>
            <div className='mainapply-input'>
              <input className='mainapply-input-input' maxLength={15} placeholder='输入主播昵称进行搜索' value={inputValue} onChange={inputChange.bind(this)}/>
              <div className='mainapply-input-button'
                onClick = {
                  () => {
                    search();
                  }
                }
              >搜索</div>
            </div>
            <div className='mainapply-inviteguest-main'>
              <div className='main-title'>
                <p>序号</p><p>主播昵称</p><p>操作</p>
              </div>
              <div className='main-user'>
                {
                  showInviteList.map(item => (
                    <div className='main-user-item' key = {JSON.stringify(item)}>
                      <div className='user-item-index'>
                        { item.index }
                      </div>
                      <div className='user-item-msg'>
                        <img
                          className='item-msg-head'
                          src={item.sLogoUrl}
                          // onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                          onError={event => {
                            event.target.onerror = null;
                            event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png'
                          }
                          }
                        />
                        <p className='item-msg-name'>{ item.sNickName }</p>
                        <p className='item-msg-subscribe'>(订阅：<span>{figureChange(item.iSubscription)}</span>)</p>
                      </div>
                      <div className='user-item-control'>
                        {
                          item.iOperatorType === 0 &&
                          <h4
                            onClick = { () => {
                              invite(item.lPid);
                            } }
                          >邀请</h4>
                        }
                        {
                          item.iOperatorType === 1 &&
                          <h5>已邀请</h5>
                        }
                        {
                          item.iOperatorType === 2 &&
                          <h5>已同意</h5>
                        }
                        {
                          item.iOperatorType === 3 &&
                          <h5>已拒绝</h5>
                        }
                        {
                          item.iOperatorType === 4 &&
                          <h6>Ta被抢走啦</h6>
                        }
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
            <div className='mainapply-page'>
              {
                showInviteList.length !== 0 &&
                  <Page
                    pageLen={inviteList.length % 3 === 0 ? inviteList.length / 3 : Math.floor(inviteList.length / 3) + 1}
                    setPageIndex={pageChange}
                  />
              }
            </div>
          </div>
        }
        {
          // 助阵嘉宾
          (userType === 2 || userType === 3) && helpMsg !== null &&
          // ((userType === 1 && tabSelect === 1) || userType === 4) && helpMsg !== null &&
          <div className='mainapply-guest'>
            <div className='Avatar'>
              <img
                className='item-msg-head'
                src= { helpMsg.sLogoUrl }
                // onClick={() => (window.open('https://m.huya.com/' + helpMsg.tJump.iRoomId, '_blank').location)}
                onError={event => {
                  event.target.onerror = null;
                  event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png'
                }
                }
              />
            </div>
            <div className='name'>
              { helpMsg.sNickName }
            </div>
            <div
              className='lift'
              onClick = { () => {
                lift(helpMsg.lPid, userType === 2 ? 7 : 6, helpMsg.sNickName);
              } }
            >
              解除助阵关系
            </div>
          </div>
        }
      </section>
      {
        twiceToast !== -2 &&
        <Assistapply
          close = { closeAssist }
          type = { twiceToast } // 1、确定报名，2、重新报名，3、重新报名先取消助阵，4、接受助阵、5、拒绝助阵，6、退出助阵，7、踢出对阵，8、邀请助阵，0、操作异常
          { ...toastData }
          userType = { userType }
        />
      }
    </div>
  )
}
export default Mainapply;